export default __webpack_public_path__ + "static/media/HTML.918d2bd3.png";